export const ADDRESS = 1;
export const EMAIL = 2;
export const PHONE = 3;
export const FACILITYPHONE = 4;

